import { render, staticRenderFns } from "./VProjectActions.vue?vue&type=template&id=68f08e0b&"
import script from "./VProjectActions.vue?vue&type=script&lang=js&"
export * from "./VProjectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports